import type { App } from 'vue'
import ElementPlus from 'element-plus'

export function installElementPlus(app: App) {
  app.use(ElementPlus)
}
